import { FC } from 'react';

import { Card, Flex, rem, Skeleton, SkeletonCircle, SkeletonText, Spacer, useBreakpointValue, VStack } from '@bonusly/design-system';

export const BonusCardSkeleton: FC = () => {
	const variant = useBreakpointValue({ base: 'flat', xs: 'full' });
	return (
		<Card boxShadow="none" p={2} variant={variant}>
			<VStack alignItems="stretch" spacing={6} width="100%">
				<Flex direction="row" alignItems="center" columnGap={2}>
					<SkeletonCircle size="12" />
					<SkeletonCircle size="12" />
					<Spacer />
					<Skeleton borderRadius="4px" height="14px" width="100px" />
				</Flex>

				<SkeletonText noOfLines={3} skeletonHeight={rem(14)} spacing={4} />
				<Skeleton borderRadius="12px" height={rem(40)} width="100%" />
				<Flex direction="row" alignItems="center" columnGap={2}>
					<Skeleton borderRadius="12px" height={rem(40)} width={rem(100)} />
					<Skeleton borderRadius="12px" height={rem(40)} width={rem(120)} />
					<Spacer />
					<Skeleton borderRadius="12px" height={rem(40)} width={rem(80)} />
				</Flex>
			</VStack>
		</Card>
	);
};
